import React from "react";
import { usePointBusinessStatisticsModel } from "../pointBusinessStatisticsModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import useGlobalModel from "@/model/globalModel";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = usePointBusinessStatisticsModel();
    const { getSelectedDictOne } = useDictModel(() => []);
    const { shopAndOrg: { shopType }, allShopDs } = useGlobalModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "客户名称",
            fieldName: "customerName"
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "单据编号",
            fieldName: "code"
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "制单员",
            fieldName: "createUser",
        },
        // {
        //     type: SearchTypeEnum.Select,
        //     placeholder: "所属站点",
        //     fieldName: "shopId",
        //     options: allShopDs,
        //     disabled: shopType === 0 ? false : true
        // },
    ]
    const searchMoreFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "商品编号",
            fieldName: "materialCode"
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "商品名称",
            fieldName: "materialName"
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "销售类型",
            fieldName: "saleTypeCode",
            options: getSelectedDictOne(DictCodeEnmu.SALES_TYPE)
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "结算类型",
            fieldName: "payType",
            options: getSelectedDictOne(DictCodeEnmu.PAYEE_TYPE)
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "客户类型",
            fieldName: "customerTypeCode",
            options: getSelectedDictOne(DictCodeEnmu.CUSTOMER_TYPE)
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "单据类型",
            fieldName: "tradeTypeCode",
            options: getSelectedDictOne(DictCodeEnmu.TRADE_TYPE)?.filter((item: any) => `${item.value}`.indexOf("maintenance") > -1) ?? []
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            rangePickerFieldName: ["settlementStartTime", "settlementEndTime"],
            placeholder: ["结算起始日期", "结算结束日期"],
            format: "YYYY-MM-DD",
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            rangePickerFieldName: ["startTime", "endTime"],
            placeholder: ["开单起始日期", "开单结束日期"],
            format: "YYYY-MM-DD",
            span: 16,
            xxl: 8,
        },
    ]
    return (
        <YhPageHeader
            title="维修明细报表"
            size="small"
            //  
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            searchMoreFields={searchMoreFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}